import PropTypes from "prop-types";
import React from "react";
import { ExportClassData } from "../../../helper/ExportData";

const HiddenExportDataset = ({ dataset }) => {
  if (!Array.isArray(dataset) || !dataset.length) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        left: "-10000px",
        top: "-10000px",
        opacity: 0,
        width: 0,
        height: 0,
      }}
    >
      <ExportClassData dataset={dataset} />
    </div>
  );
};

HiddenExportDataset.propTypes = {
  dataset: PropTypes.array,
};

HiddenExportDataset.defaultProps = {
  dataset: [],
};

export default HiddenExportDataset;

